import React, {useEffect} from 'react';
import {Card, Col, Divider, List, Row, Skeleton} from 'antd';
import useContest, {ContestType} from '../../hooks/apis/useContest';
import Title from 'antd/lib/typography/Title';
import Flex from '../../components/Flex';
import useContestNotice from '../../hooks/apis/useContestNotice';
import QuickRouter from '../../utils/QuickRouter';
import {UserType} from '../../hooks/apis/useUser';
import useAuth from '../../utils/AuthContext';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import useQuickRouter from '../../utils/QuickRouter';
import {useParams} from 'react-router-dom';

export default function ContestDetailPage() {
  const auth = useAuth();
  const queryByIdState = useContest.queryById();
  const listNoticeState = useContestNotice.list();
  const params = useParams() as {id?: string};
  const contestId = parseInt(params?.id || '');
  const contest = queryByIdState.data;
  const quickRouter = useQuickRouter();
  function refresh() {
    queryByIdState
      .request({id: contestId})
      .then(() => {
        listNoticeState.request({contestId}).catch(CommonApiErrorHandler);
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    refresh();
  }, [auth.currentUser]);

  function checkLogin(callBack: any) {
    if (!auth.currentUser) return quickRouter.login();
    else {
      callBack();
    }
  }

  return (
    <Flex justify={'center'}>
      <Card style={{width: 700}}>
        <Skeleton loading={queryByIdState.loading}>
          {contest && (
            <Flex direction={'column'} align={'center'}>
              <Title style={{margin: 5}}>{contest.name}</Title>
              <Divider />
              <Row style={{width: 500, padding: '30px 0'}} gutter={20}>
                {contest.type === ContestType.知识竞赛类 && (
                  <React.Fragment>
                    <Col span={12} className={'mb-md'}>
                      <a onClick={() => checkLogin(() => quickRouter.knowledgeTestDetail(contest?.simulationKnowledgeTestId))}>
                        <Flex align={'center'} justify={'center'}>
                          <img className={'mr-md'} src="/images/simulationKnowledgeTest.svg" alt="simulationKnowledgeTest" style={{width: 80}} />
                          <h2>答题演练</h2>
                        </Flex>
                      </a>
                    </Col>
                    <Col span={12} className={'mb-md'}>
                      <a onClick={() => checkLogin(() => quickRouter.knowledgeTestHistory(contest?.simulationKnowledgeTestId, auth.currentUser?.id || 0))}>
                        <Flex align={'center'} justify={'center'}>
                          <img className={'mr-md'} src="/images/history.svg" alt="history" style={{width: 80}} />
                          <h2>历史统计</h2>
                        </Flex>
                      </a>
                    </Col>
                    <Col span={12} className={'mb-md'}>
                      <a onClick={() => checkLogin(() => quickRouter.knowledgeTestDetail(contest?.regulationKnowledgeTestId))}>
                        <Flex align={'center'} justify={'center'}>
                          <img className={'mr-md'} src="/images/regulationKnowledgeTest.svg" alt="regulationKnowledgeTest" style={{width: 80}} />
                          <h2>正式答题</h2>
                        </Flex>
                      </a>
                    </Col>
                    <Col span={12} className={'mb-md'}>
                      <a onClick={() => checkLogin(() => quickRouter.knowledgeTestResult(contest?.regulationKnowledgeTestId, auth.currentUser?.id || 0))}>
                        <Flex align={'center'} justify={'center'}>
                          <img className={'mr-md'} src="/images/regulationKnowledgeTest.svg" alt="regulationKnowledgeTest" style={{width: 80}} />
                          <h2>查看得分</h2>
                        </Flex>
                      </a>
                    </Col>
                  </React.Fragment>
                )}
                {contest.type === ContestType.作品征集类 && (
                  <React.Fragment>
                    {auth.currentUser?.type === UserType.普通账号 && (
                      <React.Fragment>
                        <Col span={12} className={'mb-md'}>
                          <a onClick={() => quickRouter.collectionWorkUploadRecord(contest?.collectionWork.id)}>
                            <Flex align={'center'} justify={'center'}>
                              <img className={'mr-md'} src="/images/uploadWork.svg" alt="uploadWork" style={{width: 80}} />
                              <h2>上传作品</h2>
                            </Flex>
                          </a>
                        </Col>
                        <Col span={12} className={'mb-md'}>
                          <a onClick={() => quickRouter.collectionWorkMyRecords(contest?.collectionWork.id)}>
                            <Flex align={'center'} justify={'center'}>
                              <img className={'mr-md'} src="/images/mywork.svg" alt="uploadWork" style={{width: 80}} />
                              <h2>我的作品</h2>
                            </Flex>
                          </a>
                        </Col>
                      </React.Fragment>
                    )}
                    {auth.currentUser?.type === UserType.评审员 && (
                      <Col span={12} className={'mb-md'}>
                        <a onClick={() => quickRouter.collectionWorkReview(contest?.collectionWork.id)}>
                          <Flex align={'center'} justify={'center'}>
                            <img className={'mr-md'} src="/images/review.svg" alt="uploadWork" style={{width: 80}} />
                            <h2>作品评审</h2>
                          </Flex>
                        </a>
                      </Col>
                    )}
                  </React.Fragment>
                )}
              </Row>
              <Divider>活动消息</Divider>
              <List
                style={{width: '100%', marginTop: -10}}
                dataSource={listNoticeState.data}
                renderItem={item => (
                  <List.Item style={{cursor: 'pointer'}} onClick={() => quickRouter.contestNoticeDetail(item.id)}>
                    <List.Item.Meta title={item.title} description={item.publishedDate} />
                  </List.Item>
                )}
              />
            </Flex>
          )}
        </Skeleton>
      </Card>
    </Flex>
  );
}
